import React, { useState } from "react";
import "../css2/SlowDownList.css";

export default function SlowDownList() {
  const [items, setItems] = useState(["", "", ""]);
  const [submitted, setSubmitted] = useState(false);

  const updateItem = (index, value) => {
    const copy = [...items];
    copy[index] = value;
    setItems(copy);
  };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  return (
    <div className="slowdown-container">
      {!submitted ? (
        <div className="slowdown-card">
          <h1 className="slowdown-title">🌿 Slow Down List</h1>
          <p className="slowdown-subtitle">
            Drop your speed by naming what can wait.  
            Your brain will thank you for taking just a moment.
          </p>

          <div className="slowdown-inputs">
            {items.map((it, idx) => (
              <input
                key={idx}
                className="slowdown-input"
                placeholder={`Something that can wait...`}
                value={it}
                onChange={(e) => updateItem(idx, e.target.value)}
              />
            ))}
          </div>

          <button
            className="slowdown-btn"
            onClick={handleSubmit}
            disabled={items.every((i) => i.trim() === "")}
          >
            Slow Down
          </button>
        </div>
      ) : (
        <div className="slowdown-finish">
          <h2>💆‍♀️ You just released pressure.</h2>
          <p className="slowdown-finish-sub">
            Look at what you chose to pause for now:
          </p>

          <div className="slowdown-clouds">
            {items
              .filter((i) => i.trim() !== "")
              .map((i, idx) => (
                <div key={idx} className="slowdown-cloud">
                  {i}
                </div>
              ))}
          </div>

          <p className="slowdown-final-line">
            You’re allowed to slow down. One breath at a time.
          </p>
        </div>
      )}
    </div>
  );
}
